// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__b8yOb","loaderOuter":"PageOverlayLoader_loaderOuter__2kaiK"};